<template>
  <v-app-bar color="white" elevation="1" density="compact">
    <div class="d-flex align-center ml-4">
      <v-icon icon="mdi-calculator-variant" color="grey-darken-2" size="24" class="mr-1"></v-icon>
      <span class="text-body-1 font-weight-bold text-grey-darken-3">쉬운 내신 등급 계산기</span>
    </div>
    <v-spacer></v-spacer>
  </v-app-bar>
</template>

<script>
export default {
  name: 'TheHeader',
}
</script>

<style scoped>
/* v-app-bar의 내부 padding을 직접 제어하고 싶을 경우 아래 스타일 사용 가능 */
:deep(.v-toolbar__content) {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}
</style>